import {Platform} from 'react-native'
const AsyncStorage = Platform.select({
    native: () => require('react-native-encrypted-storage'),
    default: () => require('@react-native-async-storage/async-storage')
  })();

class asyncStorageFunc {

    // RNSecureStorage Methods
    storeData = async (key, value) => {

        try {

            await AsyncStorage.default.setItem(key, JSON.stringify(value));

            console.log("RNSecureStorage: Stored Data for key " + key + " with value " + JSON.stringify(value) + " in RNSecureStorage!");
        } catch (e) {
            console.log("RNSecureStorage: storeData Error ", e);
        }
    }

    getData = async (key) => {
        try {

            let value = await AsyncStorage.default.getItem(key)
            console.log('getData', value)
            if (value !== null && value !== "") {
                console.log("RNSecureStorage getData Success for ", key);
                return JSON.parse(value);
            }
        } catch (e) {
            console.log("RNSecureStorage getData Error: ", e);
        }
    }

    deleteData = async (key) => {
        try {
            await AsyncStorage.default.setItem(key, "");
            console.log("Deleted Data for " + key + " from RNSecureStorage!");
            global.prevRoute = ""
            return true;
        }
        catch (exception) {
            console.log("RNSecureStorage deleteData Error for " + key + ' :' + exception);
            return false;
        }
    }
}
export default new asyncStorageFunc;